var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckInCircleSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 19.167A9.167 9.167 0 1 0 10 .833a9.167 9.167 0 0 0 0 18.334M14.618 8.45l-5.156 5.156a.86.86 0 0 1-1.26-.048l-2.438-2.626a.86.86 0 1 1 1.215-1.215l1.97 1.97 4.454-4.453a.86.86 0 1 1 1.215 1.216",
  clipRule: "evenodd"
})));
export default SvgCheckInCircleSuccess;